import type { ReactElement } from "react";
import { cloneElement } from "react";
import { PageContext } from "./PageContext.tsx";
import { useImpressionTracking } from "./use-impression-tracking.ts";

export type PageProps = {
  /**
   * Optional component to render instead of a div. If provided, the component
   * must accept a `ref` prop.
   */
  as?: ReactElement<{
    ref?: React.Ref<HTMLElement>;
    children?: React.ReactNode;
    "data-page-name"?: string;
  }>;
  /**
   * The name of the current page. (Used for analytics.)
   */
  name: string;
  children: React.ReactNode | React.ReactNode[];
};

export const Page = ({
  as = <div style={{ display: "contents" }} />,
  name,
  children,
}: PageProps) => {
  const ref = useImpressionTracking("PAGE_VIEW", {
    properties: { page: name },
  });

  return (
    <PageContext name={name}>
      {cloneElement(as, { ref, children, "data-page-name": name })}
    </PageContext>
  );
};
